module.exports = __webpack_public_path__ + "img/shareURLImg.65565016.png";